import { Box, styled } from '@mui/material'

export const StyledMarginBox = styled(Box)(({ theme }) => ({
  height: 284,
  transition: theme.transitions.create(['height', 'margin'], {
    duration: theme.transitions.duration.standard,
  }),
}))
